export default {
  nav: {
    title: 'Stripe Subscriptions',
  }
}
